import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var CustomCardWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  color: ", ";\n  background-color: ", ";\n  background: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  gap: ", ";\n  border-radius: ", ";\n  border: none;\n  box-shadow: ", ";\n  cursor: ", ";\n  transition: background 0.3s ease;\n"], ["\n  position: ", ";\n  color: ", ";\n  background-color: ", ";\n  background: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  gap: ", ";\n  border-radius: ", ";\n  border: none;\n  box-shadow: ", ";\n  cursor: ", ";\n  transition: background 0.3s ease;\n"])), function (_a) {
    var _b = _a.$position, $position = _b === void 0 ? "relative" : _b;
    return $position;
}, function (_a) {
    var _b = _a.color, color = _b === void 0 ? "" : _b;
    return color;
}, function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? "#fff" : _b;
    return backgroundColor;
}, function (_a) {
    var _b = _a.background, background = _b === void 0 ? "" : _b;
    return background;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? "16px" : _b;
    return fontSize;
}, function (_a) {
    var _b = _a.fontWeight, fontWeight = _b === void 0 ? "normal" : _b;
    return fontWeight;
}, function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? "0" : _b;
    return margin;
}, function (_a) {
    var _b = _a.padding, padding = _b === void 0 ? "24px" : _b;
    return padding;
}, function (_a) {
    var _b = _a.textAlign, textAlign = _b === void 0 ? "center" : _b;
    return textAlign;
}, function (_a) {
    var _b = _a.textTransform, textTransform = _b === void 0 ? "none" : _b;
    return textTransform;
}, function (_a) {
    var _b = _a.width, width = _b === void 0 ? "100%" : _b;
    return width;
}, function (_a) {
    var _b = _a.$minWidth, $minWidth = _b === void 0 ? "200px" : _b;
    return $minWidth;
}, function (_a) {
    var _b = _a.$maxWidth, $maxWidth = _b === void 0 ? "300px" : _b;
    return $maxWidth;
}, function (_a) {
    var _b = _a.$height, $height = _b === void 0 ? "100%" : _b;
    return $height;
}, function (_a) {
    var _b = _a.$minHeight, $minHeight = _b === void 0 ? "220px" : _b;
    return $minHeight;
}, function (_a) {
    var _b = _a.display, display = _b === void 0 ? "flex" : _b;
    return display;
}, function (_a) {
    var _b = _a.$flexDirection, $flexDirection = _b === void 0 ? "column" : _b;
    return $flexDirection;
}, function (_a) {
    var _b = _a.alignItems, alignItems = _b === void 0 ? "center" : _b;
    return alignItems;
}, function (_a) {
    var _b = _a.$justifyContent, $justifyContent = _b === void 0 ? "normal" : _b;
    return $justifyContent;
}, function (_a) {
    var _b = _a.gap, gap = _b === void 0 ? "4px" : _b;
    return gap;
}, function (_a) {
    var _b = _a.borderRadius, borderRadius = _b === void 0 ? "8px" : _b;
    return borderRadius;
}, function (_a) {
    var _b = _a.boxShadow, boxShadow = _b === void 0 ? "0px 4px 10px rgba(0, 0, 0, 0.1)" : _b;
    return boxShadow;
}, function (_a) {
    var _b = _a.$cursor, $cursor = _b === void 0 ? "pointer" : _b;
    return $cursor;
});
var templateObject_1;
